import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: "api/options/index.php"
});


//////////////////
// WEBPACK FOOTER
// ./app/models/optionsModel.js
// module id = 22
// module chunks = 0